import { RenderSpriteData, Value2D } from "./Value2D";
import { Shader3D } from "../../../../RenderEngine/RenderShader/Shader3D";
import { Vector2 } from "../../../../maths/Vector2";
import { Vector4 } from "../../../../maths/Vector4";
import { Matrix4x4 } from "../../../../maths/Matrix4x4";
import { ShaderDefines2D } from "../ShaderDefines2D";
export class TextureSV extends Value2D {
    constructor() {
        super(RenderSpriteData.Texture2D);
        TextureSV.prototype.initialize.call(this);
    }
    initialize() {
        this._blurInfo = new Vector2();
        this._u_blurInfo1 = new Vector4();
        this._u_blurInfo2 = new Vector4();
        this._u_TexRange = new Vector4();
        this._colorMat = new Matrix4x4();
        this._colorAlpha = new Vector4();
        this._strength_sig2_2sig2_gauss1 = new Vector4();
        this._defaultShader = Shader3D.find("Sprite2DTexture");
        this.blurInfo = this._blurInfo;
        this.u_blurInfo1 = this._u_blurInfo1;
        this.u_blurInfo2 = this._u_blurInfo2;
        this.u_TexRange = this._u_TexRange;
        this.colorMat = this._colorMat;
        this.colorAlpha = this._colorAlpha;
        this.strength_sig2_2sig2_gauss1 = this._strength_sig2_2sig2_gauss1;
    }
    reinit() {
        super.initialize();
        this.initialize();
    }
    get blurInfo() {
        return this.shaderData.getVector2(ShaderDefines2D.UNIFORM_BLURINFO);
    }
    set blurInfo(value) {
        this.shaderData.setVector2(ShaderDefines2D.UNIFORM_BLURINFO, value);
    }
    get u_blurInfo1() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_BLURINFO1);
    }
    set u_blurInfo1(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_BLURINFO1, value);
    }
    get u_blurInfo2() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_BLURINFO2);
    }
    set u_blurInfo2(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_BLURINFO2, value);
    }
    get u_TexRange() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_TEXRANGE);
    }
    set u_TexRange(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_TEXRANGE, value);
    }
    get colorMat() {
        return this.shaderData.getMatrix4x4(ShaderDefines2D.UNIFORM_COLORMAT);
    }
    set colorMat(value) {
        this.shaderData.setMatrix4x4(ShaderDefines2D.UNIFORM_COLORMAT, value);
    }
    get colorAlpha() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_COLORALPHA);
    }
    set colorAlpha(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_COLORALPHA, value);
    }
    get strength_sig2_2sig2_gauss1() {
        return this.shaderData.getVector(ShaderDefines2D.UNIFORM_STRENGTH_SIG2_2SIG2_GAUSS1);
    }
    set strength_sig2_2sig2_gauss1(value) {
        this.shaderData.setVector(ShaderDefines2D.UNIFORM_STRENGTH_SIG2_2SIG2_GAUSS1, value);
    }
}
